<template>
  <a class="dropdown-item cursor-pointer" @click="handle">Send message</a>
</template>

<script>
export default {
  props: {
    message: Object,
    url: String,
  },

  methods: {
    /**
     * @return {undefined}
     */
    handle() {
      return axios.post(this.url)
          .then(this.onSuccess)
          .catch(this.onError);
    },

    /**
     * @event load-schedule-message-list
     * @event conversation-list-change
     * @return {undefined}
     */
    onSuccess({data: {message}}) {
      eventBus.$emit('load-schedule-message-list', {exclude: _.get(this.message, 'id')});

      if (!_.isNull(message)) {
        this.$message({
          message: message,
          type: 'success',
        });
      }
    },

    /**
     * @param {Object} response
     * @return {undefined}
     */
    onError({response}) {
      this.$message({
        message: _.get(response, 'data.message', 'An error occurred.'),
        type: 'error',
        iconClass: 'el-icon-error',
      });
    },
  },
}
</script>

<style scoped>

</style>
